var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var device = require('lib/device.js');

function AboutPurposeSlideshow(el) {
  this.$el = $(el);
  this.$slides = this.$el.find('.carousel-slide');

  if(Modernizr.csstransforms3d && device.browser !== 'ie') {
    this.$el.addClass('mode-fancy');
  } else {
    this.$el.addClass('mode-standard');
  }

  this.$el
    .on('click', '.carousel-slide.next, [data-carousel-control="next"]', this.nextSlide.bind(this))
    .on('click', '.carousel-slide.prev, [data-carousel-control="prev"]', this.prevSlide.bind(this))
    .on('click', '[data-carousel-control="reset"]', this.reset.bind(this));
}

AboutPurposeSlideshow.prototype.nextSlide = function() {
  var $prevOut = this.$slides.filter('.prev-out');
  var $prev = this.$slides.filter('.prev');
  var $active = this.$slides.filter('.active');
  var $next = this.$slides.filter('.next');
  var $nextUp = this.$slides.filter('.next-up');

  if(!$next.length) {
    return;
  }

  if($prevOut.length) {
    $prevOut.removeClass('prev-out');
  }

  if($prev.length) {
    $prev.removeClass('prev').addClass('prev-out');
  }

  if($active.length) {
    $active.removeClass('active').addClass('prev');
  }

  if($next.length) {
    $next.removeClass('next').addClass('active');
  }

  if($nextUp.length) {
    $nextUp.removeClass('next-up').addClass('next');
  }

  var $nextNextUp = $nextUp.next('.carousel-slide');

  if($nextNextUp.length) {
    $nextNextUp.addClass('next-up');
  }

  this.updateControls();
}


AboutPurposeSlideshow.prototype.prevSlide = function() {
  var $prevOut = this.$slides.filter('.prev-out');
  var $prev = this.$slides.filter('.prev');
  var $active = this.$slides.filter('.active');
  var $next = this.$slides.filter('.next');
  var $nextUp = this.$slides.filter('.next-up');

  if(!$prev.length) {
    return;
  }

  if($nextUp.length) {
    $nextUp.removeClass('next-up');
  }

  if($next.length) {
    $next.removeClass('next').addClass('next-up');
  }

  if($active.length) {
    $active.removeClass('active').addClass('next');
  }

  if($prev.length) {
    $prev.removeClass('prev').addClass('active');
  }

  if($prevOut.length) {
    $prevOut.removeClass('prev-out').addClass('prev');
  }

  var $nextPrevOut = $prevOut.prev('.carousel-slide');

  if($nextPrevOut.length) {
    $nextPrevOut.addClass('prev-out');
  }

  this.updateControls();
}

AboutPurposeSlideshow.prototype.updateControls = function() {
  var $active = this.$slides.filter('.active');

  if($active.is(':first-child')) {
    this.$el.find('[data-carousel-control="prev"]').attr('disabled', true);
  } else {
    this.$el.find('[data-carousel-control="prev"]').removeAttr('disabled');
  }

  if($active.is(':last-child')) {
    this.$el.find('[data-carousel-control="next"]').attr('disabled', true);
  } else {
    this.$el.find('[data-carousel-control="next"]').removeAttr('disabled');
  }
}

AboutPurposeSlideshow.prototype.reset = function() {
  var $active = this.$slides.first();

  this.$slides.removeClass('prev-out prev active next next-up');

  $active.addClass('active')
    .next('.carousel-slide').addClass('next')
    .next('.carousel-slide').addClass('next-up');

  this.updateControls();
}

module.exports = AboutPurposeSlideshow;